import React from "react";
import {Button, Slide} from "@material-ui/core";
import {cancelInstallPrompt, canShowInstallPrompt, showInstallPrompt} from "../../utils/AppInstallHelper";
import Paper from "@material-ui/core/Paper";
import TextView from "./TextView";
import {ColorTitle} from "src/styles/Colors";
import {FormattedMessage} from "react-intl";
import Space from "./Space";
import {FontWeightRegular} from "src/res/FontWeight";
import zIndex from "@material-ui/core/styles/zIndex";
import {APP_SHOWCASE} from "src/js/utils/services";
import {baseStyles} from "src/styles/Styles";
import {withStyles} from "@material-ui/core/styles";

class AppInstall extends React.Component {

  constructor() {
    super();
    this.state = {
      reload: false
    }
  }

  componentDidMount() {
    this.timeoutHandler = setTimeout(() => {
      this.onLaterClicked();
      clearTimeout(this.timeoutHandler);
      this.timeoutHandler = null;
    }, 6000);
  }

  componentWillUnmount() {
    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);
      this.timeoutHandler = null;
    }
  }

  render() {
    const {classes, isLTR, marginTop = 20, position = 'fixed'} = this.props;
    if (canShowInstallPrompt()) {
      return (
        <Slide direction="down" in={true} mountOnEnter unmountOnExit>
          <div style={{position: position, top: marginTop, display: 'flex', flexDirection: 'column', alignItems: 'center', zIndex: zIndex.snackbar, ...isLTR ? {right: 20} : {left: 20}}}>
            <Paper elevation={5}>
              <div className={classes.viewRow} style={{minWidth: 200, minHeight: 50, padding: 8}}>
                <img src={APP_SHOWCASE ? require('src/images/logo_showcase.png') : require('src/images/logo.png')} width={32} height={32} style={{borderRadius: 8}} />
                <Space verticalSpace={1.5}/>
                <TextView fontWeight={FontWeightRegular} color={ColorTitle} textId={APP_SHOWCASE ? 'showcase.installApp' : 'installApp'} textAlign={'left'} style={{minWidth: 100}} />
                <Space verticalSpace={3}/>
                <Button color="secondary" variant={'outlined'} onClick={this.onLaterClicked}><FormattedMessage id={'later'} /></Button>
                <Space verticalSpace={1}/>
                <Button color="primary" disableElevation variant={'contained'} onClick={this.onInstallClicked}><FormattedMessage id={'install'} /></Button>
              </div>
            </Paper>
          </div>
        </Slide>
      );
    }
    return null;
  }

  onLaterClicked = () => {
    cancelInstallPrompt();
    this.setState({reload: !this.state.reload});
  };

  onInstallClicked = () => {
    showInstallPrompt();
    this.setState({reload: !this.state.reload});
  };
}

export default (withStyles(baseStyles))(AppInstall);
